import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {UnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {MinRentPipe} from "../../pipes/min-rent.pipe";
import {MaxRentPipe} from "../../pipes/max-rent.pipe";
import {DollarPipe} from "../../pipes/dollar.pipe";
import {TranslocoPipe} from "@jsverse/transloco";

@Component({
  selector: 'homey-regular-rent-range',
  standalone: true,
  imports: [
    MinRentPipe,
    MaxRentPipe,
    DollarPipe,
    TranslocoPipe,
  ],
  template: `
    @let ads = regularAdvertisements();
    @if (ads.length > 0) {
      @let min = ads | minRent;
      @let max = ads | maxRent;
      @if (min === max) {
        {{ 'common.price.perMonth' | transloco : { value: (min | dollar) } }}
      } @else {
        {{ 'common.price.rangePerMonth' | transloco : { min: (min | dollar), max: (max | dollar) } }}
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegularRentRangeComponent {
  advertisements = input.required<UnitAdvertisementDto[]>();

  protected readonly regularAdvertisements = computed(
    () => this.advertisements().filter(advertisement => advertisement.type === 'regular')
  );
}
